const getColumns = showLess => {
  if (showLess) {
    return [
      {
        title: '',
        dataIndex: 'lessonNum',
        scopedSlots: { customRender: 'sections' }
      }
    ]
  }
  return [
    {
      title: '',
      dataIndex: 'lessonNum',
      scopedSlots: { customRender: 'sections' },
      width: 153
    },
    {
      title: '',
      dataIndex: 'lessonNum',
      scopedSlots: { customRender: 'before' },
      width: 106
    },
    {
      title: '',
      dataIndex: 'lessonNum',
      scopedSlots: { customRender: 'middle' },
      width: 106
    },
    {
      title: '',
      dataIndex: 'lessonNum',
      scopedSlots: { customRender: 'after' },
      width: 106
    },
    {
      title: '',
      dataIndex: 'lessonNum',
      fixed: 'right',
      scopedSlots: { customRender: 'study' },
      width: 100
    }
  ]
}

export {
  getColumns
}